export default (ms: number = 20) =>
  new Promise((resolve) => setTimeout(resolve, ms));
